<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" :tableTitle="'操作证申请列表'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="1">姓名</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th class="operation-th">操作</th>
        </template>
        <template #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el" @click="onShowType">
              <label class="cursor-el">操作证类型管理</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td>
              <div class="operation-btn-div">
                <span class="cursor-el" @click="onShowInfo(props.item)">查看</span>
                <span class="cursor-el" @click="onDel(props.item)">删除</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox"
import CertificateTypeLayer from "@/pages/layer/CertificateTypeLayer"
import CertificateInfoLayer from "@/pages/layer/CertificateInfoLayer"
import { getApplyCertificateItems, postApplyCertificateDel } from "@/common/api"

export default {
  name: "CertificateApplies",
  components: { TableBox },
  data() {
    return {
      action: getApplyCertificateItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "申请编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "类型", name: "type", title: "type", isHtml: false, value: this.getObjValue },
        { state: true, alias: "申请人", name: "applicant", title: "applicant", isHtml: false, value: this.getObjValue },
        { state: true, alias: "电话", name: "phone", title: "phone", isHtml: false, value: this.getObjValue },
        { state: true, alias: "地址", name: "address", title: "address", isHtml: false, value: this.getObjValue },
        { state: true, alias: "申请时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    tableFieldNum() {
      let num = 1;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      if(field === "type"){
        return Object.prototype.hasOwnProperty.call(item, 'type') ? item.type : '到期换证';
      }else{
        return item[field];
      }
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onShowType() {
      this.$layer.iframe({
        content: {
          content: CertificateTypeLayer,
          parent: this
        },
        area: ["800px", "600px"],
        title: "操作证类型管理"
      });
    },
    onShowInfo(item) {
      this.$layer.iframe({
        content: {
          content: CertificateInfoLayer,
          parent: this,
          data: {
            infoId: item.id
          }
        },
        area: ["800px", "650px"],
        title: "申请详情"
      });
    },
    onDel(item) {
      this.$layer.confirm(`是否删除申请？`, layerid => {
        postApplyCertificateDel({ id: item.id })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .operation-th {
      width: 80px;
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        height: 23px;
        padding: 0 10px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>